import React from 'react';
import {
  Box,
  Container,
  SimpleGrid,
  VStack,
  Text,
  Icon,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { MdCheckCircle, MdLockOpen, MdUnsubscribe } from 'react-icons/md';
import {useAppData} from '../../store/dataStore';

const MotionBox = motion(Box);

const WebinarTrust = () => {
  const { appData } = useAppData();
  const { studentsCount } = appData;
  const trustElements = [
    {
      icon: MdCheckCircle,
      title: 'No Credit Card Required',
      description: 'Completely free access',
    },
    {
      icon: MdLockOpen,
      title: 'No Obligation',
      description: 'Learn at your own pace',
    },
    {
      icon: MdUnsubscribe,
      title: 'Unsubscribe Anytime',
      description: 'Full control of your data',
    },
  ];

  return (
    <Box py={{ base: 12, md: 16 }} bg="white">
      <Container maxW="container.xl">
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8}>
          {trustElements.map((element, index) => (
            <MotionBox
              key={index}
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
            >
              <VStack spacing={3} textAlign="center">
                <Icon
                  as={element.icon}
                  boxSize={10}
                  color="accent.green"
                />
                <Text
                  fontWeight="600"
                  fontSize="lg"
                  color="brand.700"
                >
                  {element.title}
                </Text>
                <Text fontSize="sm" color="brand.500">
                  {element.description}
                </Text>
              </VStack>
            </MotionBox>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default WebinarTrust;
